import React, { useEffect, useRef, useState } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts, { color } from "highcharts";
import {
  REPORT_TYPES,
  TWITTERLEGENDS,
} from "../../../../constants/app-constant";
import { getSocialPlatformIdFromName } from "../../../../utility/common-methods";

const {
  JournalistNOARanking,
  JournalistAnalysisPrint,
  JournalistNOATrend,
  SOV_NOA_TREND,
  JournalistTonalityNOARanking,
  PublicationNOATrend,
  TonalityNAORanking,
  PublicationNOARanking,
  PublicationTonalityNOARanking,
  CityWiseNOARanking,
  CityWiseNOATrend,
  CityWiseTonality,
  CityWiseCCMTonality,
  CityWiseMAVTonality,
  CityWiseCCMRanking,
  PLATFORM_TONALITY,
  PLATFORM_TREND,
  PLATFORM_RANK,
  Reach,
  TonalityNAOTrend,
  JournalistWCRanking,
  TonalityWordCount,
  TonalityWCTrend,
  EditionWiseNOATrend,
  MediaWiseNOARanking,
  ThematicAnalysisTag,
  ThematicAnalysisEntity,
} = REPORT_TYPES;
const formatTwitterData = (data) => {
  if (!data) return;
  return TWITTERLEGENDS.map(({ name, color, entityname }) => {
    const newArray = data.map((x) => {
      const array = Object.keys(x).filter((el, index) => el == entityname);
      return parseInt(x[array]);
    });
    return {
      name: name,
      data: newArray,
      color: color,
    };
  });
};

const formatMetricData = (data) => {
  if (!data && !data.length) return;
  return data.map(({ impressions }) => parseInt(impressions));
};

const x_lables = (data) => {
  if (!data) return;
  return data.map((elm) => elm.date);
};
const formatData = ({ datasets }) => {
  if (!datasets) return;
  return datasets
    .map((elm) => ({
      name: elm.label,
      data: elm.data && elm.data.map((el) => parseInt(el, 10)),
      color: elm.backgroundColor,
    }))
    .sort((a, b) => parseFloat(b.data) - parseFloat(a.data));
};
export const LineChartHC = function ({
  graphApiResponse = { hcData: [{}] },
  onEntityClick,
  reportType,
  entityList,
  dataByReportType,
  editionList,
  isEmbededWidget,
  chartTitle,
  setGraphRef,
  setGraphRefList,
  mediaType,
  data,
  twitterFeeds,
  type,
  selectedFilter,
  metricsData,
}) {
  const ref = useRef();
  const [lineChartData, setLineChartData] = useState({});
  const metricsGraphData = [
    {
      name: "",
      data: metricsData && formatMetricData(metricsData),
      color: "#E96F6F",
    },
  ];

  useEffect(() => {
    twitterFeeds && redrawChart();
    setGraphRef(ref);
  }, [data, metricsData]);

  useEffect(() => {
    !twitterFeeds && redrawChart();
  }, [graphApiResponse]);

  const showLegends = twitterFeeds && type === "twitterKeymetrics";

  const customLabel = () => {
    if (/article/i.test(chartTitle) || /word/i.test(chartTitle))
      return "{value}";
    else return "{value}";
  };

  const convertToInternationalCurrencySystem = (labelValue) => {
    if (!labelValue) return "0";
    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e9
      ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(2) + "B"
      : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e6
      ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(2) + "M"
      : // Three Zeroes for Thousands
      Math.abs(Number(labelValue)) >= 1.0e3
      ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(2) + "K"
      : Math.abs(Number(labelValue));
  };

  const tooltip = {
    formatter: function () {
      return (
        "The value for <b>" +
        this.x +
        "</b> is <b>" +
        this.series.name +
        "</b> is <b>" +
        convertToInternationalCurrencySystem(this.y) +
        "</b>"
      );
    },
  };

  const redrawChart = () => {
    if (graphApiResponse.labels) {
      const labels = twitterFeeds
        ? type === "twitterKeymetrics"
          ? x_lables(metricsData)
          : x_lables(data)
        : graphApiResponse.labels;
      const options = {
        chart: {
          type: "line",
          animation: false,
        },
        legend: {
          enabled: !showLegends,
          maxHeight: 65,
        },
        title: {
          text: chartTitle,
          margin: 10,
          style: {
            fontSize: "12px",
            fontWeight: "bold",
            color: "#666",
          },
        },
        tooltip,
        exporting: {
          sourceWidth: 1200,
          chartOptions: {
            legend: {
              enabled: true,
              verticalAlign: "top",
              maxHeight: 1000,
              margin: 25,
              y: 70,
            },
          },
        },
        series: twitterFeeds
          ? type === "twitter"
            ? formatTwitterData(data)
            : metricsGraphData
          : formatData(graphApiResponse),
        plotOptions: {
          line: {
            marker: {
              symbol: "circle",
            },
            dataLabels: {
              enabled: false,
            },
          },
          series: {
            label: {
              connectorAllowed: false,
            },
            events: {
              click: (e) => handlePointsClick(e),
            },
          },
        },
        xAxis: {
          tickmarkPlacement: "on",
          min: 1.0,
          max: labels.length - 2.0,
          categories: labels,
          labels: {
            style: {
              fontSize: "8px",
              textOverflow: "none",
            },
          },
        },
        yAxis: {
          minPadding: 2,
          title: {
            text: null,
          },
          labels: {
            format: customLabel(),
          },
        },
      };
      setLineChartData(options);
      if (setGraphRefList) {
        setGraphRefList(reportType + mediaType, ref);
      }
    }
  };

  const handlePointsClick = (e) => {
    try {
      const {
        point: {
          category,
          series: { name },
        },
      } = e;
      const [label, legend] = [category, name];
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
        ent: selectedFilter && selectedFilter.label,
        labels: null,
      };
      let clickedEntity = label;
      if (
        // /ranking/i.test(reportType) &&
        /sov/i.test(reportType) &&
        /entity/i.test(reportType)
      ) {
        clickedEntity = legend;
      }
      if (/sov/i.test(reportType) && /publication/i.test(reportType)) {
        routeParams.publication = legend;
      }
      if (/trend/i.test(reportType)) {
        routeParams.date = label;
        if (/geolocation/i.test(reportType) && /entity/i.test(reportType)) {
          if (mediaType === 1) {
            routeParams.edition = legend;
            routeParams.media_type = 2;
          } else {
            clickedEntity = legend;
          }
        }
        if (/geolocation/i.test(reportType) && !/entity/i.test(reportType)) {
          if (/publication/i.test(reportType)) {
            routeParams.publication = legend;
          }
          if (/keyword/i.test(reportType)) {
            routeParams.keyword = legend;
          }
        }
        if (
          /journalist/i.test(reportType) &&
          (/entity/i.test(reportType) || /keyword/i.test(reportType))
        ) {
          if (/keyword/i.test(reportType)) routeParams.keyword = legend;
          if (/entity/i.test(reportType)) clickedEntity = legend;
        }
      }
      if (/sov/i.test(reportType) && /journalist/i.test(reportType)) {
        routeParams.sourceName = legend;
      }
      if (/sov/i.test(reportType) && /city/i.test(reportType)) {
        routeParams.edition = legend;
      }
      if (/sov/i.test(reportType) && /keyword/i.test(reportType)) {
        routeParams.keyword = legend;
      }
      if (
        /^publication/i.test(reportType) &&
        /Trend/.test(reportType) &&
        (/Entity/.test(reportType) ||
          /Keyword/.test(reportType) ||
          /Journalist/.test(reportType))
      ) {
        routeParams.publication = legend;
        if (/Entity/.test(reportType)) {
          if (/Trend/.test(reportType)) {
            clickedEntity = legend;
          }
        }
        if (/Keyword/.test(reportType)) {
          if (/Trend/.test(reportType)) {
            routeParams.keyword = legend;
          }
        }
        if (/Journalist/.test(reportType)) {
          if (/Trend/.test(reportType)) {
            routeParams.sourceName = legend;
          }
        }
      }

      if (/Thematic/.test(reportType)) {
        clickedEntity = label;
        if (/Entity/.test(reportType)) {
          if (/Trend/.test(reportType)) clickedEntity = legend;
        } else if (/City/.test(reportType)) {
          routeParams.edition = legend;
        } else if (/Publication/.test(reportType)) {
          routeParams.publication = legend;
        } else if (/Journalist/.test(reportType)) {
          console.log("source name changed thematic");
          routeParams.sourceName = legend;
        } else if (/Keyword/.test(reportType)) {
          routeParams.keyword = legend;
        }
      }
      if (/^Keyword/.test(reportType)) {
        clickedEntity = label;
        if (/Entity/.test(reportType)) {
          if (/Trend/.test(reportType)) clickedEntity = legend;
        } else if (/City/.test(reportType)) {
          routeParams.edition = legend;
        } else if (/Publication/.test(reportType)) {
          routeParams.publication = legend;
        } else if (/Journalist/.test(reportType)) {
          routeParams.sourceName = legend;
        } else if (/Spokesperson/.test(reportType)) {
          routeParams.spokesperson = legend;
        }
      }
      if (/^Sentiment/.test(reportType)) {
        console.log("Sentiment category");
        if (/Entity/.test(reportType)) {
          clickedEntity = legend;
        } else if (/City/.test(reportType)) {
          routeParams.edition = legend;
        } else if (/Publication/.test(reportType)) {
          routeParams.publication = legend;
        } else if (/Journalist/.test(reportType)) {
          routeParams.sourceName = legend;
        } else if (/Keyword/.test(reportType)) {
          routeParams.keyword = legend;
        }
      }
      if (/^Spokesperson/.test(reportType)) {
        console.log("Spokesperson category");
        const trend = /Trend/.test(reportType);
        if (/Entity/.test(reportType)) {
          if (trend) clickedEntity = legend;
        } else if (/Profile/.test(reportType)) {
          routeParams.profile = legend;
        } else if (/Journalist/.test(reportType)) {
          routeParams.sourceName = legend;
        } else if (/Topic/.test(reportType)) {
          routeParams.topic = legend;
        }
      }

      // if (
      //   reportType === SOV_NOA_TREND ||
      //   reportType === JournalistNOARanking ||
      //   reportType === JournalistNOATrend ||
      //   reportType === JournalistAnalysisPrint ||
      //   reportType === PublicationNOARanking ||
      //   reportType === PublicationNOATrend ||
      //   reportType === CityWiseNOATrend ||
      //   reportType === PLATFORM_RANK ||
      //   reportType === PLATFORM_TREND ||
      //   reportType === TonalityNAOTrend ||
      //   reportType === JournalistWCRanking ||
      //   reportType === MediaWiseNOARanking ||
      //   reportType === ThematicAnalysisTag ||
      //   reportType === TonalityWCTrend
      // ) {
      //   clickedEntity = legend;
      // }
      // if (
      //   reportType === SOV_NOA_TREND ||
      //   reportType === JournalistNOATrend ||
      //   reportType === JournalistAnalysisPrint ||
      //   reportType === PublicationNOATrend ||
      //   reportType === CityWiseNOATrend ||
      //   reportType === PLATFORM_TREND ||
      //   reportType == REPORT_TYPES.SOV ||
      //   reportType === TonalityNAOTrend ||
      //   reportType === TonalityWCTrend ||
      //   reportType === EditionWiseNOATrend ||
      //   twitterFeeds
      // ) {
      //   routeParams.date = label;
      // }
      // if (reportType === JournalistNOARanking) {
      //   routeParams.sourceName = label;
      //   if (isEmbededWidget) {
      //     let labelArray = label.split("[");
      //     routeParams.sourceName = labelArray
      //       .slice(0, labelArray.length - 1)
      //       .join("[");
      //   }
      // }
      // if (reportType === JournalistWCRanking) {
      //   routeParams.sourceName = label;
      // }
      // if (reportType === JournalistAnalysisPrint) {
      //   routeParams.sourceName = clickedEntity;
      // }
      // if (reportType === PublicationNOARanking) {
      //   const clickedPublication = dataByReportType.filter(
      //     (elm) => elm.publication_name == label
      //   )[0];
      //   routeParams.publication = clickedPublication;
      // }
      // if (reportType === ThematicAnalysisTag) {
      //   const clickedCategory = dataByReportType.filter(
      //     (elm) => elm.category_name == label
      //   )[0];
      //   routeParams.categoryId = clickedCategory.category_id;
      // }
      // if (reportType === ThematicAnalysisEntity) {
      //   const entityClicked = dataByReportType.filter(
      //     (elm) => elm.entity_name == label
      //   )[0];

      //   if (entityClicked && entityClicked.data && entityClicked.data.length) {
      //     const clickedCategory = entityClicked.data.filter(
      //       (elm) => elm.category_name == legend
      //     )[0];
      //     routeParams.categoryId = clickedCategory.category_id;
      //   }
      // }
      // if (
      //   reportType === CityWiseNOARanking ||
      //   reportType === EditionWiseNOATrend ||
      //   reportType === CityWiseCCMRanking
      // ) {
      //   const clickedEdition = editionList.filter(
      //     (elm) => elm.edition_name == legend
      //   )[0];
      //   routeParams.edition = clickedEdition;
      // }
      // if (reportType === MediaWiseNOARanking) {
      //   const clickedEdition = editionList.filter(
      //     (elm) => elm.edition_name == label
      //   )[0];
      //   routeParams.edition = clickedEdition;
      // }
      // if (
      //   reportType === JournalistTonalityNOARanking ||
      //   reportType === TonalityNAORanking ||
      //   reportType === PublicationTonalityNOARanking ||
      //   reportType === CityWiseTonality ||
      //   reportType === CityWiseCCMTonality ||
      //   reportType === CityWiseMAVTonality ||
      //   reportType === TonalityWordCount ||
      //   reportType === PLATFORM_TONALITY
      // ) {
      //   const tone = legend;
      //   routeParams.tonality = tone;
      // }
      // if (reportType == PLATFORM_RANK) {
      //   routeParams.channelType = getSocialPlatformIdFromName(label);
      // }
      // if (reportType == Reach) {
      //   routeParams.channelType = getSocialPlatformIdFromName(legend);
      // }
      let entity =
        entityList &&
        entityList.filter(
          (elm) =>
            clickedEntity == elm.entity_display_name?.trim() ||
            clickedEntity == elm.name || label == elm.entity_name?.trim()
        )[0];
      routeParams.entityId = entity && entity.id.toString();
      // routeParams.ent = selectedFilter && selectedFilter.label.toString();
      routeParams.labels = legend.toString();
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };
  if (graphApiResponse.labels && graphApiResponse.labels.length < 1) {
    return (
      <h6
        style={{
          textAlign: "center",
          marginTop: "25%",
        }}
      >
        {chartTitle}: No data available.
      </h6>
    );
  }
  return (
    <div className={isEmbededWidget ? "biggerWidget" : ""}>
      <HighchartsReact
        highcharts={Highcharts}
        options={lineChartData}
        ref={ref}
      />
    </div>
  );
};

LineChartHC.defaultProps = {
  graphApiResponse: {},
  onEntityClick: () => {},
  reportType: "",
  entityList: [],
  dataByReportType: {},
  editionList: [],
  isEmbededWidget: false,
  chartTitle: "",
  setGraphRef: () => {},
  setGraphRefList: () => {},
};
